define((require) => {
    "use strict";

    var ImprovedView = require("zbone/ImprovedView"),
        template = require("ui/experience/widgets/dynamicProductWidget/ShowSubWidgetView.tpl");

    return ImprovedView.extend({

        template: template,

        model: null,

        ui: {
            toggleSubwidgetRegion: ".toggle-subwidget-region"
        },

        events: {
            "change .toggle-subwidget-region": function() {
                this._toggleSubwidget(this.ui.toggleSubwidgetRegion.is(":checked"));
            }
        },

        templateHelpers: function() {
            return {
                type: this.options.type
            };
        },

        onShow: function() {
            this.__super();

            this.ui.toggleSubwidgetRegion.prop("checked", this.model.get("isVisible"));
        },

        onRender: function() {
            this.__super();

            this.ui.toggleSubwidgetRegion.prop("checked", this.model.get("isVisible"));
        },

        _toggleSubwidget(isChecked) {
            const relatedSubwidgets = this.options.subWidgetModels;
            let visibleSubwidgets = 0;

            relatedSubwidgets.forEach((widget) => {
                if (widget.get("isVisible")) {
                    visibleSubwidgets += 1;
                }
            });
            if (visibleSubwidgets !== 1 || !this.model.get("isVisible")) {
                this.model.set("isVisible", isChecked);
                this.model.trigger("transformed");
                return;
            }
            this.render();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ShowSubWidgetView.js